// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swap-layout-modal .list-container[data-v-ebc280f0] {\n  max-height: 100%;\n}\n.swap-layout-modal[data-v-ebc280f0] .ui-modal-content {\n  width: 391px !important;\n  height: 640px;\n}\n.swap-layout-modal[data-v-ebc280f0] .ui-modal-content .ui-modal-body {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
